/**
 * safe-session-storage.ts — sessionStorage wrapper that never throws.
 *
 * `sessionStorage` access throws in a few environments:
 *   • Safari in strict private-browsing mode (all writes throw).
 *   • Chromium embedded views where storage is disabled by policy.
 *   • Any code path running before the DOM has a `window` (SSR / tests).
 *
 * Every caller would otherwise need its own try/catch. This module is the
 * one place that does it, so feature code stays readable. Returns `null`
 * (or silently ignores) on failure — never surfaces the underlying error.
 */

export const safeSessionStorage = {
  get: (key: string): string | null => {
    try { return sessionStorage.getItem(key); } catch { return null; }
  },
  set: (key: string, val: string): void => {
    try { sessionStorage.setItem(key, val); } catch { /* ignore */ }
  },
};
